import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'

// Alpine.js
window.Alpine = Alpine;
Alpine.plugin(collapse)
Alpine.start();

jQuery(document).ready(function ($) {

    // Ensure that the word Green-e never breaks at the hyphen
    function wrapWordInSpan(word) {
        $('*').each(function() {
            if ($(this).children().length === 0) {
                var text = $(this).html();
                var regex = new RegExp('\\b' + word + '\\b', 'gi');
                var newText = text.replace(regex, '<span class="no-wrap">' + word + '</span>');
                // $(this).html(newText);
            }
        });
    }
     wrapWordInSpan("Green-e");

    // Accessibility menu
    $('.parent-menu').on('keydown', function (event) {

        if (event.code === 'Space') {
            event.preventDefault();
            // close open menus
            $('.sub-menu').each(function(index, element) {
                $(this).addClass('invisible scale-0');
            });

            var elm = $(this).closest('.dropdown-menu').find('.sub-menu');
            elm.toggleClass('invisible scale-0');

        }
    });

    // Get rid of pipe on utility nav
    $('.utility-link').hover(
        function() {
            // Function to execute on mouseover (or mouseenter)
            var parent = $(this).parent();
            var sibs = parent.prev('.menu-item');
            var child = sibs.find('.utility-link');
            child.toggleClass('remove-pipe');
        },
        function() {
            // Function to execute on mouseout (or mouseleave)
            var parent = $(this).parent();
            var sibs = parent.prev('.menu-item');
            var child = sibs.find('.utility-link');
            child.toggleClass('remove-pipe');
        }
    );

});

// Search filters functions
jQuery(function ($) {
  var $form = $('#product-filters');
  if (!$form.length) return;

  function getGroup($cb) {
    var name = $cb.attr('name');
    return name
      ? $form.find('input[type="checkbox"][name="' + name.replace(/"/g, '\\"') + '"]')
      : $();
  }

  function getGroupByName(name) {
    return $form.find('input[type="checkbox"][name="' + name.replace(/"/g, '\\"') + '"]');
  }

  function submitFilters() {
    $form.trigger('submit');
  }

  // Checkbox logic
  $form.on('change', 'input[type="checkbox"]', function () {
    var $cb = $(this);
    var $group = getGroup($cb);
    if (!$group.length) return;

    var $all = $group.filter('[value="all"]');

    // Clicked "all"
    if ($cb.val() === 'all') {
      if ($cb.is(':checked')) {
        $group.not($cb).prop('checked', false);
      }
      return;
    }

    // Clicked single
    if ($cb.is(':checked') && $all.length) {
      $all.prop('checked', false);
    }
  });

  // Initial state
  var seen = {};
  $form.find('input[type="checkbox"][name]').each(function () {
    var name = this.name;
    if (seen[name]) return;
    seen[name] = true;

    var $group = getGroupByName(name);
    var $all = $group.filter('[value="all"]');

    if ($all.length && $all.is(':checked')) {
      $group.not($all).prop('checked', false);
    }
  });

  // Selected filter
  var filterMap = {
    type: 'product_type[]',
    to: 'available_to[]',
    in: 'available_in[]'
  };

  $(document).on('click', '.selected-filters .filters-close', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var $chip = $(this).closest('[data-filter][data-value]');
  if (!$chip.length || $chip.data('removing')) return;

  $chip.data('removing', true);

  var filterMap = {
    type: 'product_type[]',
    to: 'available_to[]',
    in: 'available_in[]'
  };

  var filterKey = String($chip.data('filter'));
  var value = String($chip.data('value'));
  var inputName = filterMap[filterKey];

  if (!inputName) return;

  var $group = getGroupByName(inputName);
  if (!$group.length) return;

  // Uncheck dropdown
  $group.filter(function () {
    return String($(this).val()) === value;
  }).prop('checked', false);

  //re-check "all"
  var $all = $group.filter('[value="all"]');
  var anyChecked = $group.not($all).is(':checked');

  if ($all.length && !anyChecked) {
    $all.prop('checked', true);
  }

  // Fade out chip, then submit form
  $chip.stop(true, true).fadeOut(180, function () {
    submitFilters();
  });
});

  // Search postback scroll
  var params = new URLSearchParams(window.location.search);

  var shouldScroll =
    params.has('keyword') ||
    params.has('product_type[]') ||
    params.has('available_to[]') ||
    params.has('available_in[]');

  var $target = $('#product-filters');

  if (shouldScroll && $target.length) {
    $('html, body').stop().animate({
      scrollTop: $target.offset().top - 16
    }, 350);
  }
});